import { useMemo } from "react";
import { Card, Text } from "@jsq/ds/core";
import { Form } from "@jsq/ds/forms";
import { ComplianceObjectType } from "~/graphql/supergraphEnums";
import { BackButtonWithinForm } from "~/pages/Compliance/CaseDetailsDrawer/Profiles/OwnersAndControllersCard/CreateOwnersAndControllersFullscreenTakeover/BackButtonWithinForm";
import { JointProfileFields } from "~/pages/Compliance/profile/JointProfileForm/JointProfileFields";
import { buildSchema } from "~/pages/Compliance/profile/JointProfileForm/schema";
import { type FormValues } from "~/pages/Compliance/profile/JointProfileForm/types";
import { EMPTY_FORM_VALUES } from "~/pages/Compliance/profile/JointProfileForm/utils";
import { useInvestorWizard } from "../../context";
import { ProfileFormFooter } from "../ProfileFormFooter";

interface Props {
  onBack: () => void;
}

export const JointProfileForm = ({ onBack }: Props) => {
  const { setNewProfileData, setProfileDraft, goNext, profileDraft } = useInvestorWizard();

  const initialValues = useMemo(
    () =>
      profileDraft?.category === ComplianceObjectType.Joint
        ? { ...EMPTY_FORM_VALUES, ...(profileDraft.values as Partial<FormValues>) }
        : EMPTY_FORM_VALUES,
    [profileDraft],
  );

  const handleSubmit = (values: FormValues) => {
    setProfileDraft({ category: ComplianceObjectType.Joint, isPrefilled: false, values });
    setNewProfileData({
      category: ComplianceObjectType.Joint,
      accountType: values.jointType ? values.jointType : undefined,
      creationMethod: "manual",
      legalBusinessName: values.name,
      domicileCountry: values.domicileCountry || undefined,
    });
    goNext();
  };

  return (
    <Form
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={buildSchema(true)}
      submitOnlyChangedValues={false}
    >
      <Card>
        <BackButtonWithinForm onClick={onBack} displayText="Account type" />
        <Text variant="h3" marginBottom="md">
          New joint ownership
        </Text>
        <JointProfileFields isRootProfile />
      </Card>
      <ProfileFormFooter onBack={onBack} />
    </Form>
  );
};
